/*
 * Error for rethrowing api errors and indicating that they have already been handled.
 */

import { ApiError } from './Error';

export class ApiHandledError extends ApiError {}
